import { Box, BoxProps } from "@chakra-ui/react";

export default function PageSection({ children, ...rest }: BoxProps) {
  return (
    <Box as="section" padding={["1rem", "2rem", "2rem 3rem"]} {...rest}>
      {children}
    </Box>
  );
}
